import base from '~base';
// eslint-disable-next-line max-len
import { onEvent as on, addClassIfNeeded as addClass, isIOS } from '../util/domutils'; // eslint-disable-line import/named
import { ADDRESS_FORM_EVENTS } from './addressForm';
import scrollTo from '../util/scrollTo';
import $ from 'jquery';

const baseSubmit = base.submit;
const baseClearForm = base.functions.clearForm;
const baseInvalid = base.invalid;

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
  let valid = true;
  if (this.checkValidity && !this.checkValidity()) {
    // safari
    valid = false;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    // eslint-disable-next-line jquery/no-each, jquery/no-find, no-undef
    $(this).find('input, select').each(function () {
      if (!this.validity.valid) {
        // eslint-disable-next-line jquery/no-trigger, no-undef
        $(this).trigger('invalid', this.validity);
        // eslint-disable-next-line jquery/no-closest, jquery/no-class
        $(this).closest('.form-group').addClass('form-error');
        // eslint-disable-next-line jquery/no-class
        $(this).removeClass('is-valid');
      }
    });
  }
  return valid;
}

function createErrorSummary(event) {
  if (this.checkValidity && !this.checkValidity()) {
    const invalidElements = [];

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    // Collect invalid form elements
    // eslint-disable-next-line jquery/no-each, jquery/no-find
    $(this).find('input, select').each(function () {
      if (!this.validity.valid) {
        if (this.id === 'title') {
          invalidElements.push({
            label: this.id,
            id: this.id, // Store element ID
          });
        } else {
          invalidElements.push({
            label: this.placeholder.replace(/\*/g, ''), // Remove * from placeholder
            id: this.id, // Store element ID
          });
        }
      }
      if (this.validity.valid) {
        if (this.value.length > 0) {
          this.classList.add('is-valid');
        } else {
          this.classList.remove('is-valid');
        }
      }
    });

    if (invalidElements.length > 0) {
      // Clear existing error summary
      $('.error-summary-container').empty();
      // eslint-disable-next-line jquery/no-val
      const errorMessage = $('#errorSummaryMessage').val() || 'Missing or incorrect information';

      // Create error summary container
      const $errorSummary = $(`
        <div class="error-summary-main">
          <div class="error-icon"></div>
          <div class="error-summary-body">
            <p class="error-summary-heading">${errorMessage}</p>
            <ul class="list">
              ${invalidElements.map(({ id, label }) => `<li class="list-item">
              <a href="#${id}" class="error-link">${label}</a></li>`).join('')}
            </ul>
          </div>
        </div>
      `);
      // Append error summary to container
      $('.error-summary-container').append($errorSummary);

      // Scroll to the top of the page
      window.scrollTo({ top: 0, behavior: 'smooth' });

      // Add smooth scroll and focus behavior for error links
      document.querySelectorAll('.error-link').forEach((link) => {
        link.addEventListener('click', function (e) {
          e.preventDefault(); // Prevent the default anchor behavior
          const targetId = this.getAttribute('href').substring(1);
          const inputField = document.getElementById(targetId);
          if (inputField) {
            inputField.scrollIntoView({ behavior: 'smooth' });
            if (isIOS) {
              focusAndOpenKeyboard(inputField, 100);
            } else {
              setTimeout(() => {
                document.getElementById(targetId).focus();
              }, 100); // Add a slight delay to ensure scrolling is completed
            }
          }
        });
      });
    }
  }
}

function focusAndOpenKeyboard(targetElement, delay) {
  if (targetElement) {
    // Create a temporary input element to trigger the keyboard
    const tempInput = document.createElement('input');
    const parentContainer = targetElement.parentElement;

    // Append the temporary input field to the container
    parentContainer.appendChild(tempInput);

    // Focus on the temporary input to open the keyboard
    tempInput.focus();

    // After the delay, focus the target element and simulate a click
    setTimeout(() => {
      targetElement.focus();
      targetElement.click();

      // Remove the temporary input element from the DOM
      parentContainer.removeChild(tempInput);
    }, delay);
  }
}

function scrollToFirstError(parent) {
  setTimeout(() => {
    const errorEl = parent.querySelector('.form-control.is-invalid:not([disabled])');

    if (errorEl) {
      scrollTo(errorEl);
    }
  }, 1);
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
base.functions.clearForm = (form, resetValidity) => {
  baseClearForm.call(this, form);

  if (!resetValidity) {
    form.querySelectorAll('.form-control').forEach((el) => {
      if (el.required) {
        addClass(el, 'is-valid');
      }
    });
  }
};

base.functions.invalidate = (formGroup, message) => {
  const validatedMessage = message || '';
  const els = formGroup.querySelectorAll('input, select, textarea, .form-control');
  const feedbackContainer = formGroup.querySelector('.invalid-feedback');

  els.forEach((el) => {
    if (el.required) {
      el.classList.toggle('is-invalid', validatedMessage);
      el.classList.toggle('is-valid', !validatedMessage);
    }
  });

  if (feedbackContainer) {
    feedbackContainer.textContent = validatedMessage;
  }

  scrollToFirstError(formGroup);
};

base.submit = () => {
  document.querySelectorAll('form').forEach((form) => {
    form.addEventListener('submit', () => {
      // Dispatch event to show hidden address fields on submit if there are any errors
      document.dispatchEvent(new CustomEvent(ADDRESS_FORM_EVENTS.SUBMIT));
      validateForm.call(form);
      scrollToFirstError(form);
    });
  });

  baseSubmit();
};


document.querySelectorAll('.checkout-redesign form input').forEach((input) => {
  input.addEventListener('blur', (e) => {
    // eslint-disable-next-line jquery/no-is
    if ($(e.relatedTarget).is('#continueToShippingMethod')) {
      return; // Prevents focusout logic from interfering
    }
    input.setCustomValidity('');
    if (!input.validity.valid) {
      // eslint-disable-next-line prefer-destructuring
      let validationMessage = input.validationMessage;
      input.classList.remove('is-valid');
      input.classList.add('is-invalid');
      input.closest('.form-group').classList.add('form-error');
      if (input.validity.patternMismatch && input.dataset.patternMismatch) {
        validationMessage = input.dataset.patternMismatch;
      }
      if ((input.validity.rangeOverflow || input.validity.rangeUnderflow) && input.dataset.rangeError) {
        validationMessage = input.dataset.rangeError;
      }
      if ((input.validity.tooLong || input.validity.tooShort) && input.dataset.rangeError) {
        validationMessage = input.dataset.rangeError;
      }
      if (input.validity.valueMissing && input.dataset.missingError) {
        validationMessage = input.dataset.missingError;
      }
      const formGroup = input.closest('.form-group');
      const feedbackElement = formGroup ? formGroup.querySelector('.invalid-feedback') : null;
      if (feedbackElement) {
        feedbackElement.textContent = validationMessage;
      }
    } else {
      input.classList.remove('is-invalid');
      if (input.value.length > 0) {
        input.classList.add('is-valid');
      } else {
        input.classList.remove('is-valid');
      }
      input.closest('.form-group').classList.remove('form-error');
    }
  });
});

document.querySelectorAll('.checkout-redesign form input').forEach((input) => {
  input.addEventListener('focus', () => {
    input.closest('.form-group').classList.remove('form-error');
    input.classList.remove('is-invalid');
  });
});

document.addEventListener('product:afterAttributeSelect', () => {
  baseSubmit();
  baseInvalid();
});

base.buttonClick = () => {
  // Changes the handler of the base event to the overridden clearForm function,
  // so that the valid class is added to the fields and they can be styled appropriately
  on(document, 'click', 'form button[type="submit"], form input[type="submit"]', (e) => {
    // clear all errors when trying to submit the form
    base.functions.clearForm(e.delegateTarget.closest('form'));
  });
};

base.functions.loginValidation = (formGroup, message) => {
  const validatedMessage = message || '';
  const els = formGroup.querySelectorAll('input, select, textarea, .form-control');

  els.forEach((el) => {
    if (el.required && !el.parentElement.classList.contains('checkout-login-fields')) {
      el.classList.toggle('is-invalid', validatedMessage);
      el.classList.toggle('is-valid', !validatedMessage);
    }
  });
};

base.functions.validateForm = form => validateForm.call(document.querySelector(form), null);

base.buttonClickNew = () => {
  // Changes the handler of the base event to the overridden clearForm function,
  // so that the valid class is added to the fields and they can be styled appropriately
  on(document, 'click', '.checkout-shippingbtn', (e) => {
    const form = e.delegateTarget.closest('form');
    // eslint-disable-next-line jquery/no-trigger
    $('.address-lookup__footer').trigger('click');

    // Validate the form
    // eslint-disable-next-line jquery/no-class
    if ($('.checkout-shipping__type-content').hasClass('active')) {
      if (validateForm.call(form)) {
        $('.error-summary-container').empty();
        $('.address-details').remove();
        const address = {
          // eslint-disable-next-line jquery/no-val
          title: `${$('#title').val()} `,
          // eslint-disable-next-line jquery/no-val
          name: `${$('#firstName').val()} ${$('#lastName').val()}`,
          // eslint-disable-next-line jquery/no-val
          postalcode: $('#postalCode').val(),
          // eslint-disable-next-line jquery/no-val
          addressLine1: $('#addressOne').val(),
          // eslint-disable-next-line jquery/no-val
          addressLine2: $('#addressTwo').val() === '' ? null : $('#addressTwo').val(),
          // eslint-disable-next-line jquery/no-val
          addressLine3: $('#addressThree').val() === '' ? null : $('#addressThree').val(),
          // eslint-disable-next-line jquery/no-val
          city: $('#city').val(),
          // eslint-disable-next-line jquery/no-val
          phone: $('#phoneNumber').val(),
        };
        const $innerDiv = $('<div>', { class: 'address-details' });
        // eslint-disable-next-line max-len
        $innerDiv.append(`<p><span class="saveAddress-title">${address.title}</span><span class="saveAddress-name">${address.name}</span><p>`);
        $innerDiv.append(
          `<p><span>${address.addressLine1}</span>${
            address.addressLine2 ? `<span>, ${address.addressLine2}</span>` : ''
          }${address.addressLine3 ? `<span>, ${address.addressLine3}</span>` : ''}</p>`,
        );
        $innerDiv.append(`<p>${address.city}</p>`);
        $innerDiv.append(`<p>${address.postalcode}</p>`);
        $innerDiv.append(`${address.phone ? `<p>${address.phone}</p>` : ''}`);
        $('.save-address-details').append($innerDiv);
        // eslint-disable-next-line jquery/no-class
        $('.checkout-shipping__shipment').addClass('visibility-hidden');
        // eslint-disable-next-line jquery/no-class, max-len
        $('.checkout-shipping__address-btnEdit,.save-address-details,.checkout-shipping__methods,.checkout-shipping__form-submit-container,.shipping-address-details,.shipping-method-section,.giftcard-section').removeClass('d-none');
        document.querySelectorAll('.checkout-shipping__method-list input').forEach((input) => {
          input.disabled = false;
        });
        document.querySelectorAll('#address-content .checkout-step__form-submit-container')
          .forEach(element => element.classList.remove('d-none'));
      } else {
        createErrorSummary.call(form);
      }
    }

    const checkoutShippingForm = document.querySelector('.js-checkout-shipping-form');

    if (window.innerWidth <= 991 && checkoutShippingForm) {
      scrollTo(checkoutShippingForm);
    }
  });
};

base.clearAddressForm = () => {
  $(document).off('click', '.add-addresse__add-address-toggle')
    .on('click', '.add-addresse__add-address-toggle', (e) => {
      e.preventDefault();
      const url = e.target.dataset.action;
      const addressForm = document.getElementsByClassName('add-address-form')[0];
      // eslint-disable-next-line jquery/no-ajax
      $.ajax({
        url,
        type: 'GET',
        success(data) {
          const addressIdInput = document.getElementById('addressId');
          if (addressIdInput) {
            addressIdInput.value = data.newAddressId;
          }
        },
      });

      const addNewAddressSlider = document.querySelector('.add-address__container');
      if (addNewAddressSlider && window.innerWidth <= 991) {
        addNewAddressSlider.scrollTo({ top: 0, behavior: 'smooth' });
      }

      // Fields to clear - based on the form structure
      const fieldsToReset = [
        'title',
        'firstName',
        'lastName',
        'phoneNumber',
        'addressOne',
        'addressTwo',
        'addressThree',
        'addressLookup',
        'city',
        'postalCode',
      ];

      fieldsToReset.forEach((fieldId) => {
        const field = addressForm.querySelector(`#${fieldId}`);
        if (field) {
          field.value = '';
        }
      });

      // Reset any validation states
      const invalidFields = addressForm.querySelectorAll('.is-invalid');
      invalidFields.forEach((field) => {
        field.classList.remove('is-invalid');
      });

      const validFields = addressForm.querySelectorAll('.is-valid');
      validFields.forEach((field) => {
        field.classList.remove('is-valid');
      });

      const makeDefaultCheckbox = document.getElementById('makeDefaultDelivery');
      if (makeDefaultCheckbox) {
        makeDefaultCheckbox.checked = false;
      }
    });
};

$(document).on('click', '.checkout-shipping__form-submit-container', (e) => {
  // eslint-disable-next-line jquery/no-class
  if ($('#store-content').hasClass('active')) {
    // eslint-disable-next-line jquery/no-closest
    const form = e.currentTarget.closest('form');
    if (validateForm.call(form)) {
      const address = {
        // eslint-disable-next-line jquery/no-val
        title: `${$('#hubboxTitle').val()}`,
        // eslint-disable-next-line jquery/no-val
        name: `${$('#hubboxFirstName').val()} ${$('#hubboxLastName').val()}`,
        // eslint-disable-next-line jquery/no-val
        phonenumber: `${$('#hubboxPhoneNumber').val()}`,
        // eslint-disable-next-line jquery/no-val
        storename: `${$('#shippingAddressOne').val()}`,
        // eslint-disable-next-line jquery/no-val
        storeaddrees: `${$('#shippingAddressTwo').val()}`,
        // eslint-disable-next-line jquery/no-val
        shippingState: $('#shippingState').val(),
        // eslint-disable-next-line jquery/no-val
        shippingAddressCity: $('#shippingAddressCity').val(),
        // eslint-disable-next-line jquery/no-val
        shippingZipCode: $('#shippingZipCode').val(),
        // eslint-disable-next-line jquery/no-val, jquery/no-html, max-len
        shippingMethod: $('.summary__totals-shipping .order-receipt-label').html(),
      };
      const $innerDiv = $('<div>', { class: 'address-details' });
      const $customerDetails = $('<div>', { class: 'customerDetails' });
      // eslint-disable-next-line max-len
      $customerDetails.append(`<div><span class="address-summary__title">${address.title} </span><span class="address-summary__firstName">${address.name}</span></div>`);
      $innerDiv.append(`<div class="add-details address-summary__namereg">${address.storename}</div>`);
      $innerDiv.append(`<div class="add-details">${address.storeaddrees}</div>`);
      $innerDiv.append(`<div class="add-details">${address.shippingState}</div>`);
      $innerDiv.append(`<div class="add-details">${address.shippingAddressCity}</div>`);
      $innerDiv.append(`<div class="add-details">${address.shippingZipCode}</div>`);
      $customerDetails.append(`<div class="add-details">${address.phonenumber}</div>`);
      const $innerMethoddiv = $('<div>', { class: 'shippingMethod-details' });
      $innerMethoddiv.append(`<div>${address.shippingMethod}</div>`);
      $('.shippingdetails').empty().append($innerDiv);
      $('.customerDetails-data').empty().append($customerDetails);
      $('.methoddetails').empty().append($innerMethoddiv);
    }
  }
});

export default base;
